import React, { useEffect, useState } from "react";
import {
  Alert,
  Backdrop,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Radio,
  RadioGroup,
  Snackbar,
  Stack,
  Tab,
  Tabs,
  Typography,
  ListItemIcon,
  Chip,
} from "@mui/material";
import { CustomTextField } from "../../../components/common-components/CustomTextField";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import {
  CustomSelect,
  CustomSelectField,
} from "../../../components/common-components/CustomSelect";
import _ from "lodash";
const CreateNewJobDescription = ({
  jdDetails,
  newJDDescriptions,
  handleSetNewJDDescription,
  handleCreateNewJD,
  jdLevel,
  yearExperiencesList,
  setyearExperiencesList,
  setjdLevel,
  years,
  level,
  handleSetLocation,
  location,
  year,
  setYear,
}) => {
  const handleGetYears = (level) => {
    if (level === "Junior") {
      return _.slice(years, 0, 4);
    } else if (level === "Middle") {
      return _.slice(years, 4, 10);
    } else if (level === "Senior") {
      return _.slice(years, 10, 15);
    } else if (level === "Leadership") {
      return [];
    }
  };
  useEffect(() => {
    if (jdLevel) {
      setyearExperiencesList(handleGetYears(jdLevel.value));
    }
  }, [jdLevel]);
  return (
    <Box className="tab__container">
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <CustomSelect
            options={level}
            getOptionLabel={(option) => option.label}
            // value={formik.values.applyFor}
            onChange={(event, value) => {
              setjdLevel(value);
            }}
            renderInput={(params) => (
              <CustomSelectField {...params} label="level" variant="outlined" />
            )}
          />
        </Grid>
        {jdLevel && yearExperiencesList?.length > 0 && (
          <Grid item xs={6}>
            <CustomSelect
              options={yearExperiencesList}
              getOptionLabel={(option) => option.label}
              //   value={formik.values.applyFor}
              onChange={(event, value) => {
                setYear(value);
              }}
              renderInput={(params) => (
                <CustomSelectField
                  {...params}
                  label="years"
                  variant="outlined"
                />
              )}
            />
          </Grid>
        )}
      </Grid>
      <Typography
        className="heading__secondary"
        variant="h6"
        fontWeight="bold"
        gutterBottom
      >
        Location
      </Typography>
      <CustomTextField
        placeholder="Please enter the Location"
        fullWidth
        value={location}
        onChange={handleSetLocation}
      />
      <Typography
        className="heading__secondary"
        variant="h6"
        fontWeight="bold"
        gutterBottom
      >
        Ask a question about creating a new Job Description
      </Typography>
      <CustomTextField
        placeholder="Please enter the Job Description"
        fullWidth
        value={newJDDescriptions}
        onChange={handleSetNewJDDescription}
      />
      <Button className="btn" onClick={handleCreateNewJD}>
        Submit
      </Button>
      {jdDetails && (
        <>
          <Typography
            className="heading__secondary"
            variant="h5"
            fontWeight="bold"
            gutterBottom
            marginTop={"20px"}
            textAlign={"center"}
          >
            Job Description
          </Typography>
          <Card sx={{ margin: "auto", mt: 4, p: 2 }}>
            <CardHeader
              title={jdDetails.job_title}
              subheader={`${jdDetails.company} - ${jdDetails.location}`}
            />
            <CardContent>
              <Typography variant="body1" color="textSecondary" gutterBottom>
                {jdDetails.job_type} | {jdDetails.experience_level}
              </Typography>

              <Divider sx={{ my: 2 }} />
              <Typography variant="h6" marginBottom={"10px"} fontWeight={600}>
                Job Description
              </Typography>
              <Typography variant="body1" paragraph>
                {jdDetails.job_description}
              </Typography>

              <Divider sx={{ my: 2 }} />
              <Typography variant="h6" fontWeight={600}>
                Responsibilities
              </Typography>
              <List dense>
                {jdDetails.responsibilities?.length > 0 &&
                  jdDetails.responsibilities.map((responsibility, index) => (
                    <ListItem key={index}>
                      <ListItemIcon>
                        <FiberManualRecordIcon />
                      </ListItemIcon>
                      <ListItemText primary={responsibility} />
                    </ListItem>
                  ))}
              </List>

              <Divider sx={{ my: 2 }} />
              <Typography variant="h6" fontWeight={600}>
                Requirements
              </Typography>
              <Stack
                spacing={2}
                direction="row"
                justifyContent="space-between"
                paddingLeft={"16px"}
                paddingTop={"10px"}
              >
                <Box>
                  <Typography
                    variant="subtitle1"
                    marginBottom={"12px"}
                    fontWeight={600}
                  >
                    Education
                  </Typography>
                  <Typography variant="body2" padding={"4px 16px"}>
                    {jdDetails.requirements.education}
                  </Typography>

                  <Typography
                    variant="subtitle1"
                    sx={{ mt: 2 }}
                    marginBottom={"12px"}
                    fontWeight={600}
                  >
                    Experience
                  </Typography>
                  <Typography variant="body2" padding={"4px 16px"}>
                    {jdDetails.requirements.experience}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="subtitle1" fontWeight={600}>
                    Technical Skills
                  </Typography>
                  <List dense>
                    {jdDetails.requirements.technical_skills?.length > 0 &&
                      jdDetails.requirements.technical_skills.map(
                        (skill, index) => (
                          <ListItem key={index}>
                            <ListItemText primary={skill} />
                          </ListItem>
                        )
                      )}
                  </List>
                </Box>
                <Box>
                  <Typography variant="subtitle1" fontWeight={600}>
                    Soft Skills
                  </Typography>
                  <List dense>
                    {jdDetails.requirements.soft_skills?.length &&
                      jdDetails.requirements.soft_skills.map((skill, index) => (
                        <ListItem key={index}>
                          <ListItemText primary={skill} />
                        </ListItem>
                      ))}
                  </List>
                </Box>
              </Stack>

              <Divider sx={{ my: 2 }} />
              <Typography variant="h6" fontWeight={600}>
                Preferred Qualifications
              </Typography>
              <List dense>
                {jdDetails.preferred_qualifications?.length > 0 &&
                  jdDetails.preferred_qualifications.map(
                    (qualification, index) => (
                      <ListItem key={index}>
                        <ListItemIcon>
                          <FiberManualRecordIcon />
                        </ListItemIcon>
                        <ListItemText primary={qualification} />
                      </ListItem>
                    )
                  )}
              </List>

              <Divider sx={{ my: 2 }} />
              <Typography variant="h6" marginBottom={"10px"} fontWeight={600}>
                Why Join Us?
              </Typography>
              <Typography variant="body1" paragraph>
                {jdDetails.why_join_us}
              </Typography>
            </CardContent>
          </Card>
        </>
      )}
    </Box>
  );
};

export default CreateNewJobDescription;
